import { BookmarkIcon, DeleteIcon, EditIcon } from '../../icons';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '../../ui';

interface GroupRowMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  /** Whether the anchored row may be edited/deleted by the current user. */
  canModify: boolean;
  onClose: () => void;
  onEdit: () => void;
  onAssign: () => void;
  onDelete: () => void;
}

/**
 * Per-row kebab menu for a group — Edit / Assign content / Delete. Purely
 * presentational: the orchestrator owns the anchored row and wires each
 * action to the matching handler.
 */
export default function GroupRowMenu({
  anchorEl,
  open,
  canModify,
  onClose,
  onEdit,
  onAssign,
  onDelete,
}: GroupRowMenuProps) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem
        disabled={!canModify}
        onClick={() => {
          onEdit();
          onClose();
        }}
      >
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          onAssign();
          onClose();
        }}
      >
        <ListItemIcon>
          <BookmarkIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Assign content</ListItemText>
      </MenuItem>
      <MenuItem
        disabled={!canModify}
        onClick={() => {
          onDelete();
          onClose();
        }}
        sx={{ color: 'error.main' }}
      >
        <ListItemIcon sx={{ color: 'inherit' }}>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
}
